var map = {
	"./AddressForm.vue": [
		"6568",
		"chunk-2d0cfab7"
	],
	"./Authorization.vue": [
		"cc4c",
		"chunk-2d221c05"
	],
	"./DownloadApp.vue": [
		"336d",
		"chunk-33bd13d8"
	],
	"./DropFile.vue": [
		"e2fd",
		"chunk-321a2cd8"
	],
	"./DropImages.vue": [
		"ec52",
		"chunk-15d2c346"
	],
	"./FloatContainer.vue": [
		"8467",
		"chunk-12d8ea52"
	],
	"./FormDates.vue": [
		"3106",
		"chunk-2d0b8dda"
	],
	"./Languages.vue": [
		"dcf9",
		"chunk-2d229648"
	],
	"./LoadPage.vue": [
		"2417",
		"chunk-2d0b24de"
	],
	"./Loader.vue": [
		"531f",
		"chunk-54afdd16"
	],
	"./Login.vue": [
		"d910",
		"chunk-36b6a025"
	],
	"./MobileFloatMenu.vue": [
		"5cdb",
		"chunk-67b0550a"
	],
	"./Notification.vue": [
		"58ca",
		"chunk-2d0c9737"
	],
	"./OrdersBanner.vue": [
		"23a8",
		"chunk-2d0b26ee"
	],
	"./ProductCard.vue": [
		"26bd",
		"chunk-2d0b327c"
	],
	"./PullRefresh.vue": [
		"1108",
		"chunk-0df8870c"
	],
	"./Signup.vue": [
		"8735",
		"chunk-7f6cb452"
	],
	"./TranslationsLoader.vue": [
		"a8a8"
	],
	"./category/CategoryList.vue": [
		"6410",
		"chunk-40b31a9f"
	],
	"./category/components/category-children.vue": [
		"1755",
		"chunk-4d5b1dd5"
	],
	"./dashboard/product/product-dimensions-modal.vue": [
		"6981",
		"chunk-2d0d09f2"
	],
	"./dashboard/product/product-discount-modal.vue": [
		"f3a8",
		"chunk-23f8be66",
		"chunk-2d22ca3a"
	],
	"./dashboard/product/product-questions.vue": [
		"2b26",
		"chunk-3bb4fad8"
	],
	"./dashboard/product/product-reviews.vue": [
		"64d5",
		"chunk-2d0cfc85"
	],
	"./order/components/order-bol.vue": [
		"4ec9",
		"chunk-2d0ccb9d"
	],
	"./order/components/order-delete.vue": [
		"2175",
		"chunk-2d0b1a53"
	],
	"./order/components/order-details.vue": [
		"2b17",
		"chunk-2d0bd18c"
	],
	"./order/components/order-insurance.vue": [
		"be55",
		"chunk-2d21af19"
	],
	"./order/components/order-international-information.vue": [
		"78d9",
		"chunk-2d0d7fec"
	],
	"./order/components/order-own-shipping.vue": [
		"3c2e",
		"chunk-2d0c49f9"
	],
	"./order/components/order-shipment-addresses.vue": [
		"6556",
		"chunk-2d0cfa96"
	],
	"./order/components/order-shipment-information.vue": [
		"d385",
		"chunk-e51b220e"
	],
	"./order/components/order-tracking.vue": [
		"94f7",
		"chunk-2d0e59e2"
	],
	"./order/order-component.vue": [
		"cee49",
		"chunk-2d0cfab7",
		"chunk-e51b220e",
		"chunk-6932c9e6"
	],
	"./shopify/polaris-banner.vue": [
		"9684",
		"chunk-2d0e5bcf"
	],
	"./shopify/polaris-checkbox.vue": [
		"4a58",
		"chunk-2d0cb706"
	],
	"./shopify/polaris-editor.vue": [
		"31e6",
		"chunk-33d98211",
		"chunk-2d0b9445"
	],
	"./shopify/polaris-input-category-search.vue": [
		"e8b5f",
		"chunk-772aaf2a"
	],
	"./shopify/polaris-input-number.vue": [
		"cc66",
		"chunk-2d221c16"
	],
	"./shopify/polaris-input-tags.vue": [
		"144d",
		"chunk-2d0ab109"
	],
	"./shopify/polaris-input-text.vue": [
		"08c6",
		"chunk-2d0a5131"
	],
	"./shopify/polaris-message.vue": [
		"9037",
		"chunk-6bc4b2a3"
	],
	"./shopify/polaris-modal.vue": [
		"34f8",
		"chunk-2d0b9fa9"
	],
	"./shopify/polaris-select.vue": [
		"3e95",
		"chunk-2d0c5224"
	],
	"./shopify/polaris-text-field.vue": [
		"ed05",
		"chunk-2d2307da"
	],
	"./translations/accounts/messages/newUser_en.vue": [
		"e102",
		"chunk-2d224864"
	],
	"./translations/accounts/messages/newUser_es.vue": [
		"db70",
		"chunk-2d228ccd"
	],
	"./translations/faqs/faqs_en.vue": [
		"9de4",
		"chunk-2d0f0df0"
	],
	"./translations/faqs/faqs_es.vue": [
		"42ac",
		"chunk-2d0c0c16"
	],
	"./translations/messages/signup_en.vue": [
		"a3b3",
		"chunk-2d208479"
	],
	"./translations/messages/signup_es.vue": [
		"2f74",
		"chunk-2d0be147"
	],
	"./translations/payments/payments-taxes_en.vue": [
		"60da",
		"chunk-2d0cedad"
	],
	"./translations/payments/payments-taxes_es.vue": [
		"fd4cc",
		"chunk-774c1fe0"
	],
	"./translations/promotions/promotions_en.vue": [
		"13b8",
		"chunk-2d0ab2ae"
	],
	"./translations/promotions/promotions_es.vue": [
		"aa5c",
		"chunk-2d212be4"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1836";
module.exports = webpackAsyncContext;